import { subscriptionsDatasource } from 'data/datasources/subscriptions.datasource';
import { SubscriptionsResponseModel } from 'data/entities/subscriptions.entity';

interface ISubscriptionsRepository {
    getSubscriptions(): Promise<SubscriptionsResponseModel | null>;
}

class SubscriptionsRepository implements ISubscriptionsRepository {
    public getSubscriptions(): Promise<SubscriptionsResponseModel | null> {
        return subscriptionsDatasource.getSubscriptions();
    }
}

export const subscriptionssRepository: ISubscriptionsRepository = new SubscriptionsRepository();
